import { useAccountContext } from '@seek/hirer-graphql-react';
import { Hidden } from 'braid-design-system';
import { useEffect } from 'react';

import { EVENT_NAME_JOB_LIST_ADS_DISPLAYED } from 'src/App/constants/tracking';
import { PayPerPlacementProduct } from 'src/graphql/__generated__';
import { useQueryJobs } from 'src/hooks/useQueryJobs';
import { useTracking } from 'src/hooks/useTracking';
import { TabLoadTracker } from 'src/modules/events/TabLoadTracker';
import { IntercomConfiguration } from 'src/modules/intercom/IntercomConfiguration';

import { useQueryParam } from '../../../hooks/useQueryParam';
import { MainContent } from '../MainContent/MainContent';

import { JobListDesktopAndTablet } from './JobListDesktopAndTablet';
import { JobListMobile } from './JobListMobile';

export const JobsContent = () => {
  const { loading: loadingAccountInfo } = useAccountContext();
  const { trackEvent } = useTracking();

  const {
    loading: loadingJobs,
    error,
    totalCount,
    jobs,
    data: jobsData,
  } = useQueryJobs();
  const { tab } = useQueryParam();

  const jobsResultTypename = jobsData?.jobs?.__typename;
  useEffect(() => {
    // https://myseek.atlassian.net/browse/JPU-3946
    if (jobsResultTypename === 'JobsResponseSuccess') {
      const totalAds = jobs.length;
      const badges = jobs.reduce(
        (acc, job) => {
          if (job.canBeUpgraded) {
            acc.upgrade++;
          } else if (
            job.payPerPlacementEligibility.__typename ===
            'PayPerPlacementEligibleResponse'
          ) {
            if (
              job.payPerPlacementEligibility.product ===
              PayPerPlacementProduct.RECRUITER_NETWORK
            ) {
              acc.srn++;
            } else if (
              job.payPerPlacementEligibility.product ===
              PayPerPlacementProduct.SMART_HIRE
            ) {
              acc.smarthire++;
            }
          }
          return acc;
        },
        { upgrade: 0, srn: 0, smarthire: 0 },
      );

      trackEvent(EVENT_NAME_JOB_LIST_ADS_DISPLAYED, {
        adCounts: {
          totalAds,
          badges,
        },
      });
    }
  }, [jobs, jobsResultTypename, loadingJobs, trackEvent]);

  return (
    <MainContent
      error={error}
      loading={loadingAccountInfo || loadingJobs}
      totalCount={totalCount}
    >
      <TabLoadTracker jobs={jobs} />
      <IntercomConfiguration numberOfJobs={jobs.length} />

      <Hidden below="tablet">
        <JobListDesktopAndTablet jobs={jobs} tab={tab} />
      </Hidden>

      <Hidden above="mobile">
        <JobListMobile jobs={jobs} />
      </Hidden>
    </MainContent>
  );
};
